
import { Vue, Component } from 'vue-property-decorator';
import WorkbenchesService from '@/services/workbenches.service';
import lazyInject from '@/di';
import moment from 'moment';

@Component({})
export default class GMVAmountOrderDrawer extends Vue {
  visibleOrder = false;

  @lazyInject(WorkbenchesService)
  protected workbenchesService!: WorkbenchesService;


  filterForm: any = {
    amap_order_id: '',
    order_time_start: '',
    order_time_end: '',
  };

  order_time = [];
  columns = [
    {
      title: '订单号',
      dataIndex: 'order_no',
      key: 'order_no',
      align: 'center',
      width: 200,
    },
    {
      title: '城市',
      dataIndex: 'city',
      key: 'city',
      align: 'center',
      width: 100,
    },
    {
      title: '门店名称',
      dataIndex: 'shop_name',
      key: 'shop_name',
      align: 'center',
      width: 200,
    },
    {
      title: 'POI',
      dataIndex: 'poi',
      key: 'poi',
      align: 'center',
      width: 140,
    },
    {
      title: '品牌',
      dataIndex: 'ka_name',
      key: 'ka_name',
      align: 'center',
      width: 100,
    },
    {
      title: '分类名称',
      dataIndex: 'fcname',
      key: 'fcname',
      align: 'center',
      width: 100,
    },
    {
      title: '二级分类名称',
      dataIndex: 'cname',
      key: 'cname',
      align: 'center',
      width: 140,
    },
    {
      title: '商品类型',
      dataIndex: 'goods_cate',
      key: 'goods_cate',
      align: 'center',
      width: 100,
    },
    {
      title: '核销金额',
      dataIndex: 'amount',
      key: 'amount',
      align: 'center',
      width: 100,
    },
    {
      title: '下单时间',
      dataIndex: 'order_time',
      key: 'order_time',
      align: 'center',
      width: 140,
    },
    {
      title: '核销时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'center',
      width: 140,
    },
  ];

  data = [];

  userId = '';

  shopId = '';

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
    onChange: this.onChange,
  };

  onChangeOrderTime(val: any) {
    this.order_time = val;
    if (val.length) {
      this.filterForm.order_time_start = val[0].format('YYYY-MM-DD');
      this.filterForm.order_time_end = val[1].format('YYYY-MM-DD');
    } else {
      this.filterForm.order_time_start = '';
      this.filterForm.order_time_end = '';
    }
  }

  onShowSizeChange(current: number, size: number) {
    this.pagination.current = current;
    this.pagination.pageSize = size;
    this.getShopList();
  }

  async onChange(current: number, size: number) {
    this.pagination.current = current;
    this.pagination.pageSize = size;
    this.getShopList();
  }

    // handleShopDrawer(val: any) {
    //   console.log(val);
    // }

  init(val: any, userId: any) {
    this.userId = userId;
    this.shopId = val.shop_id;
    this.getShopList();
    this.visibleOrder = true;
  }

  search() {
    this.pagination.current = 1;
    this.getShopList();
  }

  resetQuery() {
    this.filterForm = {
      amap_order_id: '',
      order_time_start: '',
      order_time_end: '',
    };
    this.order_time = [];
    this.pagination.current = 1;
    this.getShopList();
  }
  async getShopList() {
    // const month = this.$route.query.month;
    const date = moment(this.$route.query.month as string, 'YYYY-MM');
    const data = {
      shop_id: this.shopId,
      user_id: this.userId,
      page: this.pagination.current,
      pageSize: this.pagination.pageSize,
      order_time_start: this.filterForm.order_time_start,
      amap_order_id: this.filterForm.amap_order_id,
      order_time_end: this.filterForm.order_time_end,
      raw_time_start: date.format('YYYY-MM-DD'),
      raw_time_end: date.endOf('month').format('YYYY-MM-DD'),
    };
    const res = await this.workbenchesService.getAdGmvOrderList(data);
    this.data = res.list;
    this.pagination.total = res.total;
  }
  close() {
    this.visibleOrder = false;
    this.data = [];
    this.pagination.current = 1;
    this.pagination.total = 0;
    this.filterForm = {
      amap_order_id: '',
      order_time_start: '',
      order_time_end: '',
    };
  }
}
